(function () {
    'use strict';
    angular
        .module('josdaviApp')
        .factory('Inscription', Inscription);

    Inscription.$inject = ['$resource'];

    function Inscription($resource) {
        var resourceUrl = 'api/inscriptions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
